import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref } from 'vue'
import { useTransactionComparisonMasterDetails } from '@/composables/useTransactionComparisonMasterDetails'

export const useLandBoardStore = defineStore('landBoard', () => {
  const landBoard = ref({})
  const { storeMasterData } = useTransactionComparisonMasterDetails()

  const loadLandBoardData = async cadasterId => {
    try {
      const response = await axios.get('/land-board/' + cadasterId)
      landBoard.value = response.data[0]
      return landBoard.value
    } catch (err) {
      console.error('loadLandBoardData error:', err)
      landBoard.value = {}
      throw err
    }
  }

  const setLandBoardData = data => {
    landBoard.value = data
    storeMasterData()
  }

  return {
    loadLandBoardData,
    landBoard,
    setLandBoardData,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLandBoardStore, import.meta.hot))
}
